import React, { Component } from 'react';
import { Container } from '@bit/ui-common.ui-components/ss-components';
import { Col, Row, Collapse, Button } from 'antd'
import { ssCommonUtils } from '@bit/ui-common.ui-components/ss-utils';
import * as paymentServices from '../../../redux/services/paymentConfirmationServices';

export default Container({
    state: s => ({ paymentData: s.paymentData }),
    services: [ paymentServices ]
},
class PaymentConfirmation extends Component {
    state = {
        message: 'We are completing your Pay.GOV transaction'
    }
    constructor(props) {
        super(props);
        this.completeOnlineCollection = this.props.services.completeOnlineCollection.bind(this);
        this.cancelOnlineCollection = this.props.services.cancelOnlineCollection.bind(this);
    }

    componentDidMount() {
        let { location } = this.props;

        if(location && location.search) {
            const decoded = location.search.replace(/&amp;/g, "&") // Used for local testing
            const rqstParams = ssCommonUtils.parseRequestParams( decoded );
            const {id, status, total, type, appFeeType, expedited, personId} = rqstParams;
            const isExpedited = (expedited === 'true');
            this.completeOnlineCollection(parseInt(id), parseFloat(total), type, appFeeType, isExpedited, personId);

            if (status === 'success') {
                this.setState({ message: 'Your payment with Pay.GOV was successful. We are completing your transaction now' });

            }
            if (status === 'failure') {
                this.setState({ message: 'Your payment with Pay.GOV has been canceled or failed. We are completing your transaction now' });
            }
        }
    }

    componentDidUpdate(prevProps){
      let { paymentData } = this.props;
      if((paymentData.confirmAuthorization=="success" || paymentData.confirmAuthorization=="failure") && prevProps.paymentData.confirmAuthorization=="trying"){
        setTimeout(() => {window.close()}, 3000);
      }
    }

    render() {
        const { message } = this.state;

        return (
            <div>
                {message}
            </div>
        );
    }
});
